/**
 * @type enum
 */
export enum Character {
	BUNNY = 'bunny',
	DRAGON = 'dragon',
}
